import { useState, useEffect } from 'react';

export function useWindowHeight() {

  const hasWindow = typeof window !== undefined;

  function getWindowHeight() {
    return {
      height: hasWindow ? window.innerHeight : null
    };
  }

  const [windowHeight, setWindowHeight] = useState(getWindowHeight());

  useEffect(() => {
    if (hasWindow) {
      function handleResize() {
        setWindowHeight(getWindowHeight());
      }

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
    return null;
  }, [hasWindow]);

  return windowHeight;
}
